import React, { Component } from 'react';
import combinate from 'combinate';
import _ from 'lodash';
import TitleReload from '../../common/TitleReload';
import { getPerCom } from '../../common/utils/combination';

export default class BasicDivision3 extends Component {
  state = {
    numbers: [],
  };

  componentDidMount() {
    this.handleReload();
  }

  getNumber = (number, index = 0) => {
    return _.toNumber(_.split(number, '')[index]);
  };

  handleReload = () => {
    const numbers = _.chain([...getPerCom(7), ...getPerCom(8), ...getPerCom(9)])
      .shuffle()
      .take(50)
      .value();

    this.setState({ numbers });
  };

  render() {
    const { numbers } = this.state;
    return (
      <React.Fragment>
        <TitleReload title="Basic Division #3" handleReload={this.handleReload} />
        <div className="flex flex-wrap gap-4 pt-5 text-lg md:text-2xl">
          {numbers.length &&
            numbers.map(number => {
              return (
                <div key={`${number.num}${number.den}`}>
                  <div className="flex flex-col">
                    <div className="px-5 bg-yellow-100 text-right">&nbsp;{`${number.num}`}</div>
                    <div className="px-5 bg-red-100">÷{`${number.den}`}</div>
                  </div>
                </div>
              );
            })}
        </div>
      </React.Fragment>
    );
  }
}
